// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6264":"51f5455a","8708":"49622082"}[chunkId] + ".chunk.css";
};